import { useTranslation } from "react-i18next";
import { ANY } from "helpers/constants";
import singleMode from "./filterBaseSingle";

const rawItems = [
	{
		key: "primary",
		value: 0,
		meta: {
			// Url z poprzedniej w wersji DZ dla zachowania zgodności linków
			url: "1",
			value: 0,
		},
	},
	{
		key: "lowerSecondary",
		value: 1,
		meta: {
			// Url z poprzedniej w wersji DZ dla zachowania zgodności linków
			url: "2",
			value: 1,
		},
	},
	{
		key: "vocational",
		value: 2,
		meta: {
			// Url z poprzedniej w wersji DZ dla zachowania zgodności linków
			url: "3",
			value: 2,
		},
	},
	{
		key: "secondary",
		value: 3,
		meta: {
			// Url z poprzedniej w wersji DZ dla zachowania zgodności linków
			url: "4",
			value: 3,
		},
	},
	{
		key: "higher",
		value: 4,
		meta: {
			// Url z poprzedniej w wersji DZ dla zachowania zgodności linków
			url: "5",
			value: 4,
		},
	},
];

export { rawItems };

export const isValid = (value) => {
	if (value === "") {
		return true;
	}
	const validValuesArray = rawItems.map((item) => item.meta.url);
	return validValuesArray.includes(value);
};

export const compute = {
	valueToApiParam: (value) => {
		const current = rawItems.find((item) => item.value === value);
		return current ? current.value : null;
	},
	valueToUrl: (value) => {
		const current = rawItems.find((item) => item.value === value);
		return current ? current.meta.url : "";
	},
	urlToApiParam: (value) => {
		if (value === ANY || !value) return null;
		const current = rawItems.find(({ meta: { url } }) => url === value)
			?.meta?.value;
		return Number(current);
	},
};

const useFilterEducation = ({ initial }) => {
	const { t } = useTranslation(["filtersAndSelectors"]);
	const items = rawItems.map((item) => ({
		...item,
		content: t(`filtersAndSelectors:education.${item.value}`),
	}));
	return {
		rawItems,
		items,
		compute,
		isValid,
		...singleMode({ items, initial, compute }),
	};
};

export default useFilterEducation;
